




































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { opcaoHabilitadoShared, campoHabilitadoShared, validateCPFCNPJ } from '@/utils/common'
import HonorarioAnestesistaEnum from '@/types/enum/HonorarioAnestesistaEnum'

@Component
export default class BackofficeHonorarioAnestesista extends Vue {
  $refs!: { honorarioAnestesista: any }

  honorarioAnestesistaRules: any = {
    valid: true,
    honorarioAnestesista: this.campoObrigatorio('honorarioAnestesista') ? [(v: any) => !!v || 'Campo obrigatório.'] : [],
    honorarioAnestesistaDocumento: [(v: any) => this.validateCPFCNPJUtil(v)],
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  campoHabilitado(prop: string) {
    return campoHabilitadoShared(this.getBackofficeGlobalStore.template, prop)
  }

  opcaoHabilitado(prop1: string, prop2: string) {
    return opcaoHabilitadoShared(this.getBackofficeGlobalStore.template, prop1, prop2)
  }

  campoObrigatorio(campo: string) {
    const formulario = this.getBackofficeGlobalStore &&this.getBackofficeGlobalStore.currentTemplate
      ? this.getBackofficeGlobalStore.currentTemplate.formulario
      : { formulario: {} }

    if (formulario
      && formulario[campo]
      && (formulario[campo].obrigatorio
        || formulario[campo].obrigatorioParaTodosOsConvenios
        || formulario[campo].obrigatorioParaConvenioParticular)
    ) {
      return true
    }
    return false
  }

  validateCPFCNPJUtil(value) {
    if (['', null, undefined].includes(value)) return 'Campo obrigatório.'
    const cleanedValue = value.replaceAll(/[\.\/-]/g, '')
    if (cleanedValue.length < 11) return 'CPF inválido'
    if (cleanedValue.length === 11) return validateCPFCNPJ(cleanedValue) || 'CPF inválido.'
    if (cleanedValue.length > 11 && cleanedValue.length < 14) return 'CNPJ inválido.'
    if (cleanedValue.length === 14) return validateCPFCNPJ(cleanedValue) || 'CNPJ inválido.'
    return false
  }

  honorarioAnestesistaChange() {
    if (this.opcaoHabilitado('honorarioAnestesista', 'honorarioAnestesistaDocumento')) {
      if (this.getBackofficeGlobalStore.solicitacaoAlterada.honorarioAnestesistaEnum !== HonorarioAnestesistaEnum.AssociacaoMedica) {
        this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'honorarioAnestesistaDocumento', value: '' })
        this.honorarioAnestesistaRules.honorarioAnestesistaDocumento.splice(0, this.honorarioAnestesistaRules.honorarioAnestesistaDocumento.length)
      } else {
        this.honorarioAnestesistaRules.honorarioAnestesistaDocumento.push((v: any) => this.validateCPFCNPJUtil(v))
      }
    }
  }
}
